import { defineComponent as _defineComponent } from 'vue'
import AdCheckbox from '@sh/components/MediaManager/AdCheckbox/AdCheckbox.ts.vue';
import TagsContainer from '@sh/components/MediaManager/TagsContainer/TagsContainer.ts.vue';
import Loading from '@sh/components/Utils/Loading.vue';
import { capitalizeFirstLetter, MediaManagerHelpers, onImageError } from '@sh/helpers';
import { MediaManager } from '@sh/types';
import { computed, ref } from 'vue';

interface Props {
  mode?: MediaManager.Mode;
  data: MediaManager.AdCard;
  isSelectionActivated?: boolean;
  isLoading?: boolean;
}

interface Emits {
  (event: 'onAdModalOpen'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AdCard.ts',
  props: {
    mode: null,
    data: null,
    isSelectionActivated: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false }
  },
  emits: ["onAdModalOpen"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'onAdModalOpen'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { mode?: MediaManager.Mode, data: MediaManager.AdCard, isSelectionActivated: boolean, isLoading: boolean };





const checkboxRef = ref<HTMLDivElement | null>(null);

const showTags = computed(() => MediaManagerHelpers.getTagsToDisplay(props.data.tags));

const isTrafficSourceContainer = computed(() => !!(props.data.trafficSource?.imagePath ?? props.data.usedOn > 0));

const metrics = computed(() =>
  props.data.metrics.slice(0, 3).map((metric) => ({
    ...metric,
    value: MediaManagerHelpers.getMetricValue(metric),
  }))
);

const replaceMode = computed(() => {
  if (props.mode === MediaManager.Mode.ADS) {
    return 'creative';
  }
  return props.mode ?? 'content';
});

function onCardContainerClick(event: Event) {
  if (props.isSelectionActivated || checkboxRef.value?.contains(event.target as Node)) {
    props.data.selected = !props.data.selected;
  } else {
    emits('onAdModalOpen');
  }
}

return { __sfc: true,emits, props, checkboxRef, showTags, isTrafficSourceContainer, metrics, replaceMode, onCardContainerClick, AdCheckbox, TagsContainer, Loading, capitalizeFirstLetter, onImageError, MediaManager }
}

})